export default "/images/vendor/quill/icons/dropdown.svg?c6cd8197101656eb7be9a80dcc6fea48";